import React from 'react';
import medhtechLogo from './logoimages/Medhtech-dark.png';

interface ContactProps {
  onClose: () => void;
}

export function Contact({ onClose }: ContactProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-[#e6e6e6] bg-white">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-[#d5a32a] rounded-xl flex items-center justify-center shadow-lg">
              <svg className="w-6 h-6 text-[#1b2c5a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-[#1b2c5a] font-['Anton'] tracking-wide">Contact Forward Sumner</h1>
              <p className="text-sm text-[#707070] font-['Roboto']">Get in touch with our team</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="px-6 py-3 bg-[#d5a32a] text-[#ffffff] rounded-xl hover:bg-[#f2c94c] transition-all duration-200 text-sm font-medium flex items-center gap-2 shadow-lg hover:shadow-xl font-['Roboto']"
            title="Close Modal"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
            Close
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          <div className="space-y-8">
            
            {/* Forward Sumner Logo Section */}
            <section className="text-center">
              <div className="flex justify-center mb-6">
                <img 
                  src="/FSEP_CPP_Logo.png" 
                  alt="Forward Sumner Economic Partnership" 
                  className="h-20 w-auto"
                />
              </div>
              <h2 className="text-2xl font-bold text-[#1b2c5a] font-['Anton'] tracking-wide mb-4">
                Forward Sumner Economic Partnership
              </h2>
            </section>

            {/* Contact Information */}
            <div className="grid md:grid-cols-2 gap-6">
              
              {/* Mailing Address */}
              <div className="bg-gradient-to-br from-[#f8f9fa] to-white p-6 rounded-xl border border-[#e6e6e6] shadow-sm">
                <h3 className="text-xl font-bold text-[#1b2c5a] mb-4 flex items-center gap-3 font-['Anton']">
                  <div className="w-8 h-8 bg-[#d5a32a] rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#1b2c5a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  Mailing Address
                </h3>
                <div className="space-y-2 text-[#707070] font-['Roboto'] leading-relaxed">
                  <p>P.O. Box 1071</p>
                  <p>Hendersonville, TN 37077</p>
                </div>
              </div>

              {/* Physical Address */}
              <div className="bg-gradient-to-br from-[#f8f9fa] to-white p-6 rounded-xl border border-[#e6e6e6] shadow-sm">
                <h3 className="text-xl font-bold text-[#1b2c5a] mb-4 flex items-center gap-3 font-['Anton']">
                  <div className="w-8 h-8 bg-[#d5a32a] rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#1b2c5a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  Physical Address
                </h3>
                <div className="space-y-2 text-[#707070] font-['Roboto'] leading-relaxed">
                  <p>1598 GreenLea Boulevard</p>
                  <p>Gallatin, Tennessee 37066</p>
                </div>
              </div>

              {/* Phone */}
              <div className="bg-gradient-to-br from-[#f8f9fa] to-white p-6 rounded-xl border border-[#e6e6e6] shadow-sm">
                <h3 className="text-xl font-bold text-[#1b2c5a] mb-4 flex items-center gap-3 font-['Anton']">
                  <div className="w-8 h-8 bg-[#d5a32a] rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#1b2c5a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  Phone
                </h3>
                <div className="space-y-2 text-[#707070] font-['Roboto'] leading-relaxed">
                  <p className="font-medium text-[#1b2c5a]">Chris Taylor</p>
                  <a href="tel:615-206-6624" className="text-[#d5a32a] hover:text-[#1b2c5a] transition-colors">
                    615-206-6624
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="bg-gradient-to-br from-[#f8f9fa] to-white p-6 rounded-xl border border-[#e6e6e6] shadow-sm">
                <h3 className="text-xl font-bold text-[#1b2c5a] mb-4 flex items-center gap-3 font-['Anton']">
                  <div className="w-8 h-8 bg-[#d5a32a] rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#1b2c5a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                    </svg>
                  </div>
                  Email
                </h3>
                <div className="space-y-2 text-[#707070] font-['Roboto'] leading-relaxed">
                  <a href="mailto:lori@forwardsumner.org" className="text-[#d5a32a] hover:text-[#1b2c5a] transition-colors">
                    lori@forwardsumner.org
                  </a>
                </div>
              </div>
            </div>

            {/* Social Media & Additional Info */}
            <section>
              <h3 className="text-2xl font-bold text-[#1b2c5a] mb-6 flex items-center gap-3 font-['Anton'] tracking-wide">
                <div className="w-8 h-8 bg-[#d5a32a] rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-[#1b2c5a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9m0 9c-5 0-9-4-9-9s4-9 9-9" />
                  </svg>
                </div>
                Connect with Forward Sumner
              </h3>
              
              <div className="bg-gradient-to-r from-[#1b2c5a] to-[#162844] p-6 rounded-xl text-white">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div className="space-y-2 font-['Roboto']">
                    <p><strong>Mailing:</strong> PO Box 1071, Hendersonville, Tennessee 37077</p>
                    <p><strong>Physical:</strong> 1598 GreenLea Boulevard, Gallatin, Tennessee 37066</p>
                    <p><strong>Contact:</strong> lori@forwardsumner.org | 615‑206‑6624</p>
                  </div>
                  
                  <div className="flex gap-4">
                    <a 
                      href="https://facebook.com/forwardsumner" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-[#d5a32a] rounded-lg flex items-center justify-center hover:bg-[#f2c94c] transition-colors"
                      title="Facebook"
                    >
                      <svg className="w-5 h-5 text-[#1b2c5a]" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                      </svg>
                    </a>
                    <a 
                      href="https://linkedin.com/company/forward-sumner" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-[#d5a32a] rounded-lg flex items-center justify-center hover:bg-[#f2c94c] transition-colors"
                      title="LinkedIn"
                    >
                      <svg className="w-5 h-5 text-[#1b2c5a]" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                    </a>
                    <a 
                      href="https://instagram.com/forwardsumner" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-[#d5a32a] rounded-lg flex items-center justify-center hover:bg-[#f2c94c] transition-colors"
                      title="Instagram"
                    >
                      <svg className="w-5 h-5 text-[#1b2c5a]" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                      </svg>
                    </a>
                  </div>
                </div>
                
                <div className="mt-6 pt-4 border-t border-[#d5a32a]/30 text-center">
                  <p className="text-sm text-[#d5a32a] font-['Roboto']">
                    © Forward Sumner Economic Partnership
                  </p>
                  <p className="text-xs text-white/80 mt-2 font-['Roboto'] flex items-center justify-center gap-2">
                    Website by{" "}
                    <a
                      href="https://www.medhtech.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#d5a32a] hover:text-white transition-colors duration-200 flex items-center gap-2"
                    >
                      <div className="bg-white p-1 rounded">
                        <img
                          src={medhtechLogo}
                          alt="MedTech LLC"
                          className="h-6 w-auto"
                        />
                      </div>
                    </a>
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

